import { PLATFORM } from 'aurelia-pal';

export function configure(config) {
  config.globalResources([
    PLATFORM.moduleName('./value-converters/date-converter'),
    PLATFORM.moduleName('./value-converters/date-input-converter'),
    PLATFORM.moduleName('./value-converters/date-time-converter'),
    PLATFORM.moduleName('./value-converters/category-converter'),
    PLATFORM.moduleName('./value-converters/notification-step'),
    PLATFORM.moduleName('./value-converters/cleanInputValueConverter'),
    PLATFORM.moduleName('./value-converters/upvStatus-converter'),
    PLATFORM.moduleName('./binding-behaviors/dynamic-category-list-binding-behavior'),
    PLATFORM.moduleName('./attributes/draggable-dialog'),
    PLATFORM.moduleName('./attributes/inputMaskAttribute'),
    PLATFORM.moduleName('./attributes/no-list-action'),
    PLATFORM.moduleName('./attributes/perfect-scrollbar'),
    PLATFORM.moduleName('./attributes/split-pane-collapse-on-click'),
    PLATFORM.moduleName('./attributes/theme-selector'),
    PLATFORM.moduleName('./attributes/unchecked-to-indetermined'),
    PLATFORM.moduleName('../agElements/editors/agSearchableSelectEditor'),
  ]);
}
